import { intercomService } from "@services/intercomService";
import { WSEmptyState } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";

export const EmptyStateNotFound: React.FC = () => {
  const history = useHistory();

  return (
    <WSEmptyState
      hasBorder
      orientation="horizontal"
      type="tasks"
      title="Sorry, what you're looking for doesn't exist!"
      description={
        <>
          If you need help, please{" "}
          <a onClick={intercomService.open}>contact support</a> and our team
          will be happy to help you
        </>
      }
      actions={{
        buttons: [
          {
            label: "Back to home",
            onClick: () => history.push("/member/dashboard")
          }
        ]
      }}
    />
  );
};
